<div class="edit-container">
    <h1 class="edit-title mb-0">Redirecționează email</h1>

    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="inbox-detail__content" *ngIf="data">
            <!-- Informații email -->
            <div class="email-info-section">
                <div class="info-row">
                    <strong>Subiect:</strong>
                    <span>{{ data.subject }}</span>
                </div>
                <div class="info-row">
                    <strong>De la:</strong>
                    <span>{{ data.from_name }} &lt;{{ data.from_email }}&gt;</span>
                </div>
                <div class="info-row">
                    <strong>Dată trimis:</strong>
                    <span>{{ data.received_date_time | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
                </div>
                <div class="info-row">
                    <strong>CC:</strong>
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Email</mat-label>
                        <input type="cc" matInput formControlName="cc" />
                    </mat-form-field>
                </div>
            </div>

            <!-- Conținut Email -->
            <div class="email-content-section">
                <h4>Conținut Email</h4>
                <div class="email-body" [innerHTML]="data.body"></div>
            </div>

            <div class="attachments-section" *ngIf="data.attachments && data.attachments.length > 0">
                <div class="attachments-list">
                    <div class="attachment-item" *ngFor="let attachment of data.attachments">
                        <div class="attachment-icon" [class.not-processed]="!attachment.processed_server">
                            <span class="file-extension">{{ attachment.extension.toUpperCase() }}</span>
                        </div>

                        <div class="attachment-info">
                            <div class="attachment-name" [title]="attachment.name_original">
                                {{ attachment.name_original }}
                            </div>
                            <div class="attachment-meta" *ngIf="attachment.doc_id">
                                <span class="meta-badge">
                                    Înregistrat: {{ attachment.doc_id }}
                                </span>
                            </div>
                        </div>

                        <button
                            *ngIf="attachment.processed_server && permissionsService.hasPermission('indoc-module.inbox.download-file')"
                            class="attachment-download" (click)="downloadAttachment(attachment)"
                            [title]="'Descarcă ' + attachment.name_original">
                            <i class="fa-solid fa-download"></i>
                            Descarcă
                        </button>
                    </div>
                </div>
            </div>

            <!-- Secțiune observații -->
            <div class="reply-section">
                <h4>Observații</h4>

                <angular-editor formControlName="redirect_observatii" [config]="editorConfig"></angular-editor>


                <button type="button" class="btn btn-info mt-2" (click)="onTemplates()">
                    Șabloane
                </button>
            </div>

            <div class="mt-3">
                <label class="form-label">Redirecționează către</label>

                <!-- Dropdown pentru selecție -->
                <mat-form-field class="w-100">
                    <mat-label>Selectează email</mat-label>
                    <mat-select [formControl]="emailSelectControl" (selectionChange)="onEmailSelected($event)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="emailControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredEmails.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option *ngFor="let email of filteredEmails" [value]="email">
                            {{ email.email }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!-- Buton pentru adăugare destinatar nou -->
                <button type="button" class="btn btn-outline-primary my-2 w-100" (click)="openAddDestinationDialog()">
                    <i class="fa-solid fa-plus me-2"></i>
                    Adaugă destinatar nou
                </button>

                <!-- Chipuri pentru emailurile selectate -->
                <div class="selected-emails-chips" *ngIf="selectedEmails.length > 0">
                    <div class="email-chip" *ngFor="let email of selectedEmails">
                        <span>{{ email }}</span>
                        <button type="button" class="remove-chip" (click)="removeSelectedEmail(email)">
                            <i class="fa-solid fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>